import script from "./StakingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./StakingModal.vue?vue&type=script&setup=true&lang=js"

import "./StakingModal.vue?vue&type=style&index=0&id=b2d87250&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2d87250"]])

export default __exports__